// Typelizer digest 4bde89b511a89818898e17592b98cfed
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** DELETE /c/:company_id/company_identities/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/company_identities/:id', params, options),
    method: 'delete',
  }),
}
